<template lang="pug">
	th
		.th-body(@click="toggleSort($event)")
			div.th-body-inner
				slot
			i.la(:class="iconClass")
</template>

<script>
import Vue from 'vue';
export default {
  name: 'SortColumn',
  props: {
    field: String,
    sorter: {
      // Backward compatibility:
      // Old usage: sorter = { field, direction } 
      // New usage: sorter = [{ field, direction }] – allows multi-column sorting
      type: [Array, Object],
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    iconClass() {
      // Backward Compatibility: Normalize sorter to array
      const sorterArray = Array.isArray(this.sorter) ? this.sorter : [this.sorter];

      const sortItem = sorterArray.find(s => s.field === this.field);
      if (!sortItem) return '';
      return 'la-sort-' + (sortItem.direction === 'asc' ? 'up' : 'down');
    }
  },
  methods: {
    toggleSort(event) {
      let direction = this.computeDirection();

      // Backward compatibility: old single sorter object
      if (!Array.isArray(this.sorter)) {
        // update the object directly so the parent sees the change
        if (this.sorter.field === this.field) {
          Vue.set(this.sorter, 'direction', direction);
        }
        Vue.set(this.sorter, 'field', this.field);
      }

      this.$emit('sort', { field: this.field, direction, event });
    },
    computeDirection() {
      // Backward Compatibility: Normalize sorter to array
      const sorterArray = Array.isArray(this.sorter) ? this.sorter : [this.sorter];

      const sortItem = sorterArray.find(s => s.field === this.field);

      if (sortItem) {
        return sortItem.direction === 'asc' ? 'desc' : 'asc';
      }

      // Default sort DESC
      return 'desc';
    },
  },
};
</script>
